export default {
  mounted () {
    this.focusStep()
  }
}
